//Test git
//Helen's comment
import { Component, OnInit } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';

@Component({
  selector: 'pps-employee-action',
  template: `
    <a class="action-icon p-p-1 p-mr-3 text-primary" *ngIf="canModifyEmployee" (click)="editEmployee($event)" href="#"><i class="fas fa-user-edit fa-lg" title="Edit employee"></i></a>
    <a class="action-icon p-p-1 text-danger" *ngIf="activeEmployee && canModifyEmployee" (click)="terminateEmployee($event)" href="#"><i class="fas fa-user-minus fa-lg" title="Terminate employee"></i></a>
    <a class="action-icon p-p-1 text-success" *ngIf="!activeEmployee && canModifyEmployee" (click)="activateEmployee($event)" href="#"><i class="fas fa-user-plus fa-lg" title="Reactivate employee"></i></a>
  `,
  styles: [
  ],
})
export class EmployeeActionComponent implements AgRendererComponent {
  private params: any;

  constructor() { }
  refresh(params: any): boolean {
    return true;
  }

  agInit(params: import("ag-grid-community").ICellRendererParams): void {
    this.params = params;
  }

  afterGuiAttached?(params?: import("ag-grid-community").IAfterGuiAttachedParams): void {
    throw new Error("Method not implemented.");
  }

  editEmployee(evt){
    evt.preventDefault();
    this.params.context.componentParent.openEmployeeForm(this.params.data);
  }

  terminateEmployee(evt){
    evt.preventDefault();
    this.params.context.componentParent.activateEmployee(this.params.data, false);
  }

  activateEmployee(evt){
    evt.preventDefault();
    this.params.context.componentParent.activateEmployee(this.params.data, true);
  }

  get activeEmployee(){
    return this.params.data.active;
  }

  get canModifyEmployee(){
    return this.params.context.componentParent.canModifyEmployee();
  }
}
